import { useFeatureIsOn } from "@growthbook/growthbook-react";

// Define all feature flags used in the application
export const FEATURE_FLAGS = {
  AIRCRAFT_OPS: "aircraft:ops",
  ENABLE_PLAY_BUTTON_FOR_GREEN_COURSE: "play-button",
  LOCALIZATION: "localization",
  NOTIFICATION_CENTRE: "notification-centre",
  NOTIFICATION_SETTINGS: "notification-settings",
} as const;

export type FeatureFlag = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

/**
 * Custom hook to check if a feature flag is enabled
 * @param flagName - The name of the feature flag to check
 * @returns boolean - true if the feature is enabled, false otherwise
 */
export const useFeatureFlag = (flagName: FeatureFlag): boolean => {
  const isEnabled = useFeatureIsOn(flagName);
  return isEnabled;
};

export default useFeatureFlag;
